<template>
  <div class="container-fluid">
    <Breadcrumb :values="{ Home: '/', Users: '/users', [this.$route.name === 'edit-user' ? 'Edit' : this.$route.name === 'user-page' ? 'View' : 'Add']: ''}"></Breadcrumb>
    <div class="row">
      <div class="col-12 col-lg-8">
        <div v-if="user" class="card">
          <div v-if="this.$route.name === 'edit-user'" class="card-header">
            <strong>Edit user</strong>
            {{ `${userData.firstname} ${userData.lastname}` }}
          </div>
          <div v-else-if="this.$route.name === 'user-page'" class="card-header">
            <strong>View user</strong>
          </div>
          <div v-else class="card-header">
            <strong>Add user</strong>
          </div>
          <div class="card-body">
            <EditUser
                v-if="['edit-user', 'user-page'].includes($route.name)"
                :form-data="formData"
                :editable="userEditable && checkEditPrivileges()"
                :id="userData.id"></EditUser>
            <AddUser v-else :form-data="formData"></AddUser>
          </div>
          <div v-if="this.$route.name === 'user-page'" class="card-footer">
            <a :href="`/users/${$route.params.id}/edit/`">
              <button type="reset" class="btn btn-sm btn-yellow"
                      :disabled="!checkEditPrivileges()"><i
                  class="fa fa-edit"></i> Edit
              </button>
            </a>
          </div>
          <div v-else class="card-footer">
            <button type="button" class="btn btn-sm btn-primary mr-2"
                    :disabled="!checkEditPrivileges() || !checkSalesClients()" @click="sendData"><i
                class="fa fa-dot-circle-o"></i> Submit
            </button>
            <button type="button" class="btn btn-sm btn-danger" v-if="this.$route.params.id"
                    @click="clearForm" :disabled="!checkEditPrivileges()"><i class="fa fa-ban"></i> Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import AddUser from '../components/UserDetails/AddUser'
import Breadcrumb from '../components/shared/Breadcrumb'
import EditUser from '../components/UserDetails/EditUser'
import generalActions from '../store/modules/general/actionTypes'
import usersActions from '../store/modules/users/actionTypes'
import userMutations from '../store/modules/users/getterTypes'

export default {
  name: 'UserDetails',
  components: { Breadcrumb, AddUser, EditUser },
  data () {
    return {
      userData: {},
      formData: {
        email: '',
        firstname: '',
        lastname: '',
        status: 'enabled',
        role_id: '',
        deleted: false,
        clients: [],
        password: ''
      },
      userEditable: false
    }
  },
  computed: {
    ...mapGetters({
      roles: userMutations.GET_ROLES
    }),
    user () {
      return this.formData
    },
    editedUserId () {
      return parseInt(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions({
      toggleLoading: generalActions.TOGGLE_LOADING,
      getUser: usersActions.FETCH_USER,
      getRoles: usersActions.FETCH_ROLES,
      updateUser: usersActions.UPDATE_USER
    }),
    async sendData () {
      const url = this.$route.params.id ? `/users/${this.$route.params.id}/` : '/users/'
      const method = this.$route.params.id ? 'PUT' : 'POST'
      this.formData.clients = JSON.stringify(this.formData.clients)
      const response = await this.updateUser({ method, url, data: this.formData })
      if (response.status === 200) {
        this.$router.push({ name: 'user-list' })
      } else {
        console.error(response)
      }
    },
    checkEditPrivileges () {
      if (this.editedUserId) {
        const currUser = this.$auth.user()
        return currUser.permissions.isAdmin || currUser.id === this.editedUserId
      }
      return true
    },
    checkSalesClients () {
      if (this.formData.role_id === this.roles.find(role => role.slug === 'sales').id) {
        if (this.formData.clients.length === 0) {
          return false
        } else {
          return true
        }
      }
      return true
    },
    clearForm () {
      this.formData = {
        email: '',
        firstname: '',
        lastname: '',
        status: 'enabled',
        role_id: this.roles.find(role => role.slug === 'client').id,
        clients: [],
        deleted: false,
        password: ''
      }
    }
  },
  watch: {
    userData (newData) {
      newData.status = newData.status ? 'enabled' : 'disabled'
      this.formData = newData
    }
  },
  async beforeMount () {
    this.toggleLoading(true)
    await this.getRoles()
    if (this.$route.params.id) {
      await this.getUser(this.$route.params.id).then(response => {
        this.userData = response.data
        this.formData = this.userData
      })
    }
    if (['add-user'].includes(this.$route.name)) {
      this.userEditable = true
      this.formData.role_id = this.roles.find(role => role.slug === 'client').id
    } else if (['edit-user'].includes(this.$route.name)) {
      this.userEditable = true
      this.formData.clients = this.userData.clients.map(el => el.client)
    } else if (['user-page'].includes(this.$route.name)) {
      this.userEditable = false
      this.formData.clients = this.userData.clients.map(el => el.client)
    }
    this.toggleLoading(false)
  }
}
</script>

<style scoped>

</style>
